import {createSelector} from 'reselect'
import {generatePath} from '@modifi/router'
import {FeInputFieldStatus} from '@modifi/enums'

import {selectCompanyIsLocked} from '../../../../data/company'
import {selectCombinedInputFieldStatusBySectionName} from '../../../../modules/input-fields'
import {ROUTE_COMPANY_PROFILE_INTERMEDIARY_SHAREHOLDERS_BY_ID} from '../../../../routes/constants'
import {selectIntermediaryShareholders} from '../../../../data/intermediary-shareholders'
import DeleteShareholderButton from '../../../../features/delete-intermediary-shareholder'
import {SECTION_ULTIMATE_BENEFICIAL_OWNERS} from '../../../../constants/sections'

export const selectShareholderSummaryData = createSelector(
  selectIntermediaryShareholders,
  selectCompanyIsLocked,
  (state: Record<string, any>) => state,
  (shareholders, companyIsLocked, state) => {
    const isVerified =
      selectCombinedInputFieldStatusBySectionName(state, SECTION_ULTIMATE_BENEFICIAL_OWNERS) ===
      FeInputFieldStatus.VERIFIED
    const summaryData = shareholders.map(shareholder => {
      const name = shareholder?.companyName
      return {
        route: generatePath(ROUTE_COMPANY_PROFILE_INTERMEDIARY_SHAREHOLDERS_BY_ID, {
          externalId: shareholder?.externalId,
        }),
        name: name || '',
        votingSharePercentage: shareholder?.votingShare,
        deleteButton: companyIsLocked || isVerified ? null : DeleteShareholderButton,
        deleteProps: {target: name, externalShareholderCompanyId: shareholder?.externalId},
      }
    })
    return summaryData
  }
)
